<template>
  <div class="footer"
       :class="language === 'zh' ? 'footer-zh' : 'footer-en'">
    <div v-if="showMojing"
          class="foot-text">{{$t('footer.data_E_commerce')}}</div>
    <div v-if="showMojing && language == 'en'"
          class="foot-summarized">{{$t('footer.data_summarized')}}</div>
    <div v-if="showMojing"
          class="foot-number">
      <span>{{$t('footer.company')}}</span>
      <a href="https://beian.miit.gov.cn/"
          target="_blank">{{$t('footer.ICP_number')}}</a> |
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502037832"
          target="_blank">
        <img src="https://static.mktindex.com/common/images/gonganlogo.png"
              style="vertical-align: -3px; width: 15px">
        {{$t('footer.network_security')}}
      </a>
    </div>
  </div>
</template>


<script>
export default {
  data(){
    return {}
  },
  props: {
    showMojing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    language() {
      return localStorage.getItem('language')
    },
  },
}
</script>

<style lang="less" scoped>
.footer {
  position: fixed;
  z-index: 2000;
  width: 100%;
  color: #7d8a9b;
  font-weight: 400;
  background-color: #2c2f33;
  padding: 15px 20px;
  bottom: 0;
  .foot-text {
    text-align: center;
  }
}
.footer-zh {
  height: 80px !important;
  font-weight: 400;
  .foot-number {
    text-align: center;
    padding-top: 10px;
  }
}
.footer-en {
  height: 100px !important;
  font-weight: 400;
  .foot-summarized {
    text-align: center;
    padding: 5px 0px;
  }
  .foot-number {
    text-align: center;
    padding-top: 0px;
  }
}
</style>